'use strict';

var cov_1rpjex3loq = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/PriceType.js',
      hash = '4f37bfec1fad1693885fef399ef3a56112f2cd0f',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/PriceType.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 18
        },
        end: {
          line: 6,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceType = (cov_1rpjex3loq.s[0]++, _propTypes2.default.shape({
  amount: _propTypes2.default.number,
  currencyCode: _propTypes2.default.string
}));

exports.default = PriceType;